export const checkExportInquiryConstants = {
    GET_SUCCESS: "GET_SUCCESS",
    GET_FAILURE: "GET_FAILURE",
    GET_LOADING: "GET_LOADING",
    GET_DELETE: "GET_DELETE",
};
